<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";

/**
 * Email verification component
 */
export default {
  page: {
    title: "Email verification",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      tryingToResend: false,
      resendError: null,
      isResendError: false
    };
  },
  components: {},
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...notificationMethods,
    resend() {
      this.tryingToResend = true;
      // Reset the authError if it existed.
      this.resendError = null;
      this.isResendError = false;
      this.$axios.post('/verify_email/resend', {
        email: this.$auth.user().email,
        redirect: `${window.location.origin}/verify_email/success`
      }).then((response) => {
        this.tryingToResend = false;
        this.isResendError = false;
        this.success(response.data.message);
        return response;
      }).catch((error) => {
        this.resendError = error ? error : "";
        this.tryingToResend = false;
        if (error.response && error.response.data && error.response.data.message)
          this.resendError = this.$t(error.response.data.message) || "";
        else
          this.resendError = error ? error : "";
        this.isResendError = true;
        this.error(this.resendError);
      });
    }
  },
};
</script>

<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center mb-5 text-muted">
            <router-link to="/" class="d-block auth-logo">
              <img
                src="@/assets/images/logo-dark.png"
                alt=""
                height="20"
                class="auth-logo-dark mx-auto"
              />
              <img
                src="@/assets/images/logo-light.png"
                alt=""
                height="20"
                class="auth-logo-light mx-auto"
              />
            </router-link>
<!--            <p class="mt-3">Responsive Bootstrap 5 Admin Dashboard</p>-->
          </div>
        </div>
      </div>
      <!-- end row -->
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card">
            <div class="card-body">
              <div class="p-2">
                <div class="text-center">
                  <div class="avatar-md mx-auto">
                    <div class="avatar-title rounded-circle bg-light">
                      <i class="bx bxs-envelope h1 mb-0 text-primary"></i>
                    </div>
                  </div>
                  <div class="p-2 mt-4">
<!--                    <b-alert-->
<!--                      :show="!!notification.message"-->
<!--                      :variant="(notification.type || '').split('-')[1]"-->
<!--                      class="mt-3 text-start"-->
<!--                      dismissible-->
<!--                      @dismissed="clear"-->
<!--                    >{{ notification.message }}</b-alert-->
<!--                    >-->
                    <h4>{{ lodash.upperFirst($t('verify_email.verify_your_email')) }}</h4>
                    <p style="white-space: pre" v-html="lodash.upperFirst($t('verify_email.verify_email_message', { email: `<span class='fw-semibold'>${$auth.user().email}</span>` }))"></p>
                    <div class="mt-4">
                      <router-link to="/" class="btn btn-primary w-md"
                        >{{ lodash.upperFirst($t('verify_email.verify_email')) }}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5 text-center">
            <p>
              {{ lodash.upperFirst($t('verify_email.didnt_receive_an_email')) }}
              <a v-if="!tryingToResend && !notification.message" href="" @click.prevent="resend" class="fw-medium text-primary"> {{ lodash.upperFirst($t('verify_email.resend')) }} </a>
              <span v-else-if="(notification.type || '').split('-')[1] === 'success'" @click="clear">{{ lodash.upperFirst($t('verify_email.sent')) }}</span>
              <span v-else-if="(notification.type || '').split('-')[1] === 'danger'" @click="clear">{{ lodash.upperFirst($t('verify_email.failed')) }}</span>
              <span v-else class="fw-medium text-primary">{{ lodash.upperFirst($t('verify_email.sending')) }}</span>
            </p>
            <p>
              © {{ new Date().getFullYear() }} Tirta Farm
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
